<template>
    <div class="ml-4">
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" icon="credit-card"></vue-fontawesome>        
            <router-link class="ml-2 text-decoration-none"
                to="/debtors">
                <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                Debtors
            </router-link>   
            / {{debtor.customer_name}}
        </h1>        
        <div>
            <div class="d-flex justify-content-between">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Debtor detail
                            </a>
                        </li>                                                						
                </ul>
                <!-- add buttons -->        
                <div class="d-none">
                    <button class="btn btn-success">Add deposit</button>
                </div>        
            </div>									
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab"> 
                     <!-- running balance -->
                     <div v-if="details" class="mb-4 p-2 ">
                            running balance: <span class="font-weight-bold text-success">{{details.running_balance | intcomma}} </span> |
                            total required: <span class="font-weight-bold text-success">{{details.total_required | intcomma }} </span>
                    </div>
                    <div class="d-flex justify-content-start">                                                                   
                        <div class="col-lg-12 border border-light rounded shadow">
                            <table class="table table-borderless">
                                    <thead>
                                        <tr>                                            
                                        <th scope="col">Date</th>
                                        <th scope="col">Receipt</th>
                                        <th scope="col">Order number</th>
                                        <th scope="col">Balance</th>
                                        <th></th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="details">
                                        <tr v-for="(invoice,index) in details.unsettled_invoices" :key="index">                                                
                                            <td>{{invoice.date | dateformat}}</td>
                                            <td>{{invoice.receipt_id}}</td>
                                            <td>{{invoice.order_number}}</td>
                                            <td>{{invoice.balance | intcomma}}</td>
                                            <td>
                                                <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    Actions
                                                </a>
                                                <span class="dropdown-menu">                                                                                                                                                                                                                                                                                                                                              
                                                    <a 
                                                        class="dropdown-item cursor-pointer"
                                                        @click="selectInvoice(invoice)"
                                                        data-toggle="modal" data-target="#settleDebtModal">                                                        
                                                        Settle debt
                                                    </a>                                                    										
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                    </div>                                                                                     
                </div>                               
            </div> 		  
        </div>	
        <!-- modals -->
        <section>
           <!-- settle debt modal -->
           <div class="modal fade" id="settleDebtModal" tabindex="-1" role="dialog" aria-labelledby="settleDebtModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header border-0">
                    <h5 class="modal-title" id="exampleModalCenterTitle">                            
                        settle debt<br/>
                    </h5>
                    <button type="button" id="closeTransferStockModal" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form id="settleDebtForm">
                    <div class="modal-body">                                           
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">amount</label>
                                <input type="number" class="col-8 form-control" v-model="amount"/>                                   
                            </div>                                                                                                                                           
                    </div>
                    <div class="modal-footer border-0">                            
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" id="closeSettleDebtModal">Close</button>
                        <button type="submit" class="btn btn-success"
                            @click="settleDebt()">                                                        
                            settle debt
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="settling_debt"></span>
                        </button>
                    </div>
                </form>                
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'debtorDetail',    
    data(){
        return{            
            debtor : this.$route.query.debtor,
            details: null,
            invoice: null,
            settling_debt: false,
            amount: null,
        }
    },  
    mounted(){        
        this.getDebtorDetails()
    },
    methods:{        		        
        //get debtor details
        getDebtorDetails: function(){
            this.$http({
                method:'get',
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/debtors/${this.debtor.customer_id}`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },                
            }).then((response)=>{
                this.details = response.data
            }).catch((err)=>{
                this.$emit('success',err)
            })
        },
        selectInvoice: function(invoice){
            this.invoice = invoice
            this.amount = invoice.balance
        },
        //delete product.
        settleDebt: function(){            
            var confirmed = confirm(`Do you want to settle debt for receipt ${this.invoice.receipt_id} ?`);
            if (confirmed) {
                this.settling_debt = true
                this.$http({
                    method:'post',
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/settlement/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },   
                    data:{
                        customer_id : this.details.customer_id,
                        invoice_id: this.invoice.receipt_id,
                        amount_paid: this.amount
                    }         
                }).then(()=>{                    
                    document.getElementById('closeSettleDebtModal').click()
                    this.settling_debt = false
                    this.amount = null                    
                    this.getDebtorDetails()
                    this.$emit('success',`debt settled for receipt ${this.invoice.receipt_id}`)
                }).catch((err)=>{
                    document.getElementById('closeSettleDebtModal').click()
                    this.settling_debt = false
                    this.amount = null
                    this.$emit('alert',err)
                })
            }
        },
    }
}
</script>